import React from "react";

const Footer = () => {
  return (
    <footer className="footer py-4" style={{ backgroundColor: "#343a40", color: "#fff" }}>
      <div className="container" style={{margin:"auto"}}>
        {/* Footer Top Section */}
        <div className="row text-center mb-4">
          {/* Stats Section */}
          <div className="col-md-3">
            <div>
              <i className="fas fa-school fa-2x" style={{ color: "#ff6f00" }}></i>
              <h4 className="mt-2">10+</h4>
              <p>Years of Experience</p>
            </div>
          </div>
          <div className="col-md-3">
            <div>
              <i className="fas fa-user-graduate fa-2x" style={{ color: "#ff6f00" }}></i>
              <h4 className="mt-2">4500+</h4>
              <p>Students Registered and Got Placed</p>
            </div>
          </div>
          <div className="col-md-3">
            <div>
              <i className="fas fa-tools fa-2x" style={{ color: "#ff6f00" }}></i>
              <h4 className="mt-2">100+</h4>
              <p>Equipment</p>
            </div>
          </div>
          <div className="col-md-3">
            <div>
              <i className="fas fa-chalkboard-teacher fa-2x" style={{ color: "#ff6f00" }}></i>
              <h4 className="mt-2">10+</h4>
              <p>Expert Trainers</p>
            </div>
          </div>
        </div>

        {/* Footer Middle Section */}
        <div className="row text-center text-md-left">
          {/* About Section */}
          <div className="col-md-4 mb-3">
            <h5 className="footer-heading">About The Civil Lab</h5>
            <p>
              The Civil Lab provides hands-on training to future civil engineers,
              empowering them with industry-ready skills and knowledge.
            </p>
          </div>

          {/* Quick Links Section */}
          <div className="col-md-4 mb-3">
            <h5 className="footer-heading">Quick Links</h5>
            <ul className="list-unstyled">
              <li>
                <a href="/" className="footer-link" style={{ color: "#fff" }}>
                  Home
                </a>
              </li>
              <li>
                <a href="/about" className="footer-link" style={{ color: "#fff" }}>
                  About
                </a>
              </li>
              <li>
                <a href="/training" className="footer-link" style={{ color: "#fff" }}>
                  Training
                </a>
              </li>
              <li>
                <a href="/testimonials" className="footer-link" style={{ color: "#fff" }}>
                  Testimonials
                </a>
              </li>
              <li>
                <a href="/contact" className="footer-link" style={{ color: "#fff" }}>
                  Contact
                </a>
              </li>
              <li>
                <a href="/engagements" className="footer-link" style={{ color: "#fff" }}>
                  Engagements
                </a>
              </li>
              <li>
                <a href="/faq" className="footer-link" style={{ color: "#fff" }}>
                  FAQ
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Us Section */}
          <div className="col-md-4 mb-3">
            <h5 className="footer-heading">Contact Us</h5>
            <p>
              <i className="fas fa-map-marker-alt"></i> Kursi Road, Lucknow <br />
              <i className="fas fa-phone-alt"></i> +91 7897651111 <br />
              <i className="fas fa-envelope"></i>{" "}
              <a href="mailto:info@thecivillab.in" style={{ color: "#fff" }}>
                info@thecivillab.in
              </a>
            </p>
            {/* Social Media Icons */}
            <div className="social-icons mt-3">
              <a
                href="https://www.linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="mx-2"
                style={{ color: "#fff" }}
              >
                <i className="fab fa-linkedin fa-2x" style={{ color: "#fff" }}></i>
              </a>
              <a
                href="https://www.facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="mx-2"
                style={{ color: "#fff" }}
              >
                <i className="fab fa-facebook-square fa-2x" style={{ color: "#fff" }}></i>
              </a>
              <a
                href="https://www.instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="mx-2"
                style={{ color: "#fff" }}
              >
                <i className="fab fa-instagram fa-2x" style={{ color: "#fff" }}></i>
              </a>
              <a
                href="https://www.youtube.com"
                target="_blank"
                rel="noopener noreferrer"
                className="mx-2"
                style={{ color: "#fff" }}
              >
                <i className="fab fa-youtube fa-2x" style={{ color: "#fff" }}></i>
              </a>
            </div>
          </div>
        </div>

        {/* Footer Bottom Section */}
        <div className="text-center mt-4">
          <small>&copy; {new Date().getFullYear()} The Civil Lab. All rights reserved.</small>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
